<template>
  <div class="container activate">
    <h1 class="section-title">Activation Process Completed</h1>
    <div class="text-normal" v-if="activation.is_partial">
      The profile was partially completed. An SMS has been sent for the customer to complete their profile.
    </div>
    <div class="text-normal" v-if="!activation.is_partial">
      Congratulations, your customers profile &amp; sim are now active.
      <h6 class="text-strong">The new mobile number is: {{ activation.msisdn }}</h6>
    </div>
    <button class="btn btn-primary mt-3" v-on:click="activateAnother">Activate Another Sim</button>
  </div>
</template>

<script>

export default {
  name: "complete",
  props: ['activation'],
  mounted() {
    var self = this;
    self.$scrollTo("body");
  },
  methods: {
    activateAnother() {
      window.location = "/reseller"
    }
  }
};
</script>